import { Injectable } from '@angular/core';
import { PolizaStoreService } from '../../../comun/services/store/poliza-store.service';
import { BehaviorSubject } from 'rxjs';
import { AgrupacionPolizasSalud } from '../../../comun/model/recomendador.model';
import { DatosRecomendadorPropuesta } from '../../../comun/model/salud.model';

@Injectable({
  providedIn: 'root'
})
export class PolizaSaludStoreService extends PolizaStoreService{
    private agrupacionesPoliza = new BehaviorSubject<AgrupacionPolizasSalud[]>(null);
    agrupacionesPoliza$ = this.agrupacionesPoliza.asObservable();
    private datosRecomendador = new BehaviorSubject<DatosRecomendadorPropuesta>(null);
    datosRecomendador$ = this.datosRecomendador.asObservable();

    setAgrupacionPolizasSalud(colectivasAgrupacion: AgrupacionPolizasSalud[]): void {
      this.agrupacionesPoliza.next(colectivasAgrupacion);
    }
  
    getColectivasAgrupacion(): AgrupacionPolizasSalud[]{
      return this.agrupacionesPoliza.value;
    }
    
    limpiarColectivasAgrupacion(): void {
      this.agrupacionesPoliza.next(null);
    }

    limpiarDatosRecomendador(): void {
      this.datosRecomendador.next(null);
    }

    setDatosRecomendador(datosRecomendador: DatosRecomendadorPropuesta): void {
      this.datosRecomendador.next(datosRecomendador);
    }

    override limpiarStore(): void {
      this.limpiarPoliza();
      this.limpiarColectivasAgrupacion();
      this.limpiarDatosRecomendador();
    }
}
